import { DateTime } from 'luxon';

import { accountsSelectors } from 'app-components/flux/accounts';
import { transactionsTypes } from 'app-components/flux/transactions';
import type { TransactionProps } from 'app-components/flux/transactions/transactionsTypes';
import store from 'app-components/utils/redux-store';

// SIMPL-31987: INVESTMENT-typed txns that land in a *bank* account (Fidelity Cash
// Management sweeps). No sandbox FI produces this shape, so these rows let you
// exercise the register's investment handling without aggregation.
const baseSweepTxn = (accountId: string, postedOn: string) => ({
  accountId,
  postedOn,
  type: 'INVESTMENT',
  investmentTxnType: 'BUY',
  commission: 0,
  coa: { type: 'UNCATEGORIZED', id: '0' },
  state: 'CLEARED',
  matchState: 'NOT_MATCHED',
  source: 'QCS_REFRESH',
});

/**
 * Builds the two row shapes from the SIMPL-31987 report, for every cash/bank
 * account in the dataset:
 *
 * 1. Priced sweep — `units` + `symbol` resolve, so the Category column renders
 *    "12.34 SPAXX shares @ 1.0000" instead of the real category.
 * 2. Unpriced sweep — no units/symbol, so `investmentTransactionDescription`
 *    falls back to `payee`: Payee renders blank and the payee shows up under
 *    Category.
 */
const mockBankInvestmentTransactions = () => {
  if (!store) return [];

  const postedOn = DateTime.now().minus({ days: 1 }).toISODate() ?? '';
  const accounts = accountsSelectors.getCashAccounts(store.getState());

  return accounts
    .toIndexedSeq()
    .toArray()
    .flatMap((account) => {
      const accountId = account.id;
      if (!accountId) return [];

      return [
        transactionsTypes.mkInvestmentTransaction({
          ...baseSweepTxn(accountId, postedOn),
          id: `dev-inv-${accountId}-priced`,
          payee: 'You Bought SPAXX',
          symbol: 'SPAXX',
          securityName: 'Fidelity Government Money Market',
          units: 12.34,
          amount: 12.34,
        } as Partial<TransactionProps>),

        transactionsTypes.mkInvestmentTransaction({
          ...baseSweepTxn(accountId, postedOn),
          id: `dev-inv-${accountId}-unpriced`,
          payee: 'FID BKG SVC LLC MONEYLINE',
          symbol: '',
          securityName: '',
          units: 0,
          amount: -250,
        } as Partial<TransactionProps>),
      ];
    });
};

export default mockBankInvestmentTransactions;
